import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import CustomLoader from '../../elements/CustomLoader'
import Pagination from '../Pagination'
import ReconciliationsTable from './ReconciliationsTable'
import OrdersTable from './OrdersTable'
import { Table } from 'semantic-ui-react'
import { sortByAttr } from '../../helpers/arrayHelpers'
import { DIRECTION_ASC, DIRECTION_DESC } from '../../constants/search_filters'

// TODO: move this to a stylesheet
export const BORDER_STYLE = '1px solid rgba(34, 36, 38, 0.1)'

// TODO: to get around a CSS issue of the table border extending too far, the <Table> was
// given no border and then styling added to individual cells.  This should be refactored.
class SortableOrdersTable extends React.Component {
  sortableHeaderCell = (data, index) => {
    const { sortAttr, sortDirection } = this.props
    const iconClass= `icon angle ${sortDirection === DIRECTION_ASC ? "up" : "down"}`

    return (
      <Table.HeaderCell
        key={`orders-table-header-${data.label}-${index}`}
        style={{cursor: "pointer", borderTop: BORDER_STYLE, borderRight: data.borderRight || ''}}
        onClick={() => data.attr ? this.handleSortToggle(data.attr) : null}
      >
        {data.label}
        {sortAttr === data.attr && <i className={iconClass} style={{paddingLeft: "5px"}} />}
      </Table.HeaderCell>
    )
  }

  handleSortToggle(newAttr) {
    const { sortAttr, sortDirection } = this.props
    let newSortDirection = DIRECTION_DESC

    if (newAttr === sortAttr) {
      newSortDirection = sortDirection === DIRECTION_ASC ? DIRECTION_DESC : DIRECTION_ASC
    }
    this.props.dispatch({
      type: 'SHOP_ORDER_FILTERS_UPDATE',
      payload: { sort_attr: newAttr, sort_direction: newSortDirection, current_page: 1 }
    })
    this.props.dispatch({ type: 'SHOP_ORDERS_FILTER_SAGA' })
  }

  updateOrder = (payload) => {
    this.props.dispatch({
      type: 'SHOP_ORDERS_UPDATE_SAGA',
      payload: payload
    })
  }

  renderEmptyContent = () => {
    return (
      <div className='sortable-table' style={{textAlign: "center"}}>
        {this.props.order_scopes.length > 0 ? <h3>No orders found.</h3> : <h3>Please select one of the order status</h3>}
      </div>
    )
  }

  render() {
    const {
      orders, adminUser, isLoading, isReconciliation, checklistItems, current_page, total_pages, noHeader
    } = this.props
    const ordersPresent = orders != null && orders.length > 0

    return (
      <Fragment>
        {isLoading && <CustomLoader addMarginTop={noHeader} />}
        {!isLoading && !ordersPresent && this.renderEmptyContent()}
        {!isLoading && ordersPresent &&
          <Fragment>
            <Table
              fixed singleLine striped celled
              className='sortable-table'
              style={{borderTop: 0, borderRight: 0, borderBottom: 0}}
            >
              {isReconciliation &&
                <ReconciliationsTable
                  sortableHeaderCell={this.sortableHeaderCell}
                  orders={orders}
                  updateOrder={this.updateOrder}
                />
              }
              {!isReconciliation &&
                <OrdersTable
                  checklistItems={checklistItems}
                  sortableHeaderCell={this.sortableHeaderCell}
                  orders={orders}
                  adminUser={adminUser}
                  updateOrder={this.updateOrder}
                />
              }
            </Table>
            {!isLoading && total_pages > 1 &&
              <Pagination currentPage={current_page} totalPages={total_pages} />
            }
          </Fragment>
        }
      </Fragment>
    )
  }
} // SortableOrdersTable

const mapStateToProps = (state) => {
  const shopOrders = state.shopOrders || {}
  const customers = state.customers || {}
  const filters = state.shopOrderFilters.currentFilters || {}
  console.log(filters)
  const orders = (shopOrders.orders || []).map(so => {
    so.originator = (customers.customers || []).find(c => so.originator_id === c.id) || {}
    return so
  })
  const checklistItems = sortByAttr((shopOrders.checklistItems || []), 'position', 'asc')

  return {
    sortAttr: filters.sort_attr,
    sortDirection: filters.sort_direction,
    checklistItems: checklistItems,
    adminUser: shopOrders.admin_user,
    current_page: shopOrders.current_page,
    total_pages: shopOrders.total_pages,
    orders: orders,
    isLoading: state.application.isLoading,
    order_scopes: filters.order_scopes ?? [],
  }
}

export default connect(mapStateToProps)(SortableOrdersTable)
